import { render, staticRenderFns } from "./RelatorioParcelaPaisagem.vue?vue&type=template&id=45357098"
import script from "./RelatorioParcelaPaisagem.vue?vue&type=script&lang=js"
export * from "./RelatorioParcelaPaisagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports